import * as React from "react";
import { forwardRef } from "react";
const SvgMainArrowBot = (props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 59.207"
    ref={ref}
    {...props}
  >
    <path d="M93.34.014a6.25 6.25 0 0 0-4.285 2.123L50 46.76 10.945 2.137a6.25 6.25 0 0 0-8.814-.586 6.25 6.25 0 0 0-.586 8.814L40.588 55c4.908 5.61 13.916 5.61 18.824 0l39.043-44.635A6.25 6.25 0 0 0 93.34.014" />
  </svg>
);
const ForwardRef = forwardRef(SvgMainArrowBot);
export default ForwardRef;
